import { render, staticRenderFns } from "./notificationCenter.vue?vue&type=template&id=02f85aba&scoped=true"
import script from "./notificationCenter.vue?vue&type=script&lang=js"
export * from "./notificationCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f85aba",
  null
  
)

export default component.exports